// @flow
import Enum from 'common/enums/Enum';
import EntityTypeEnum from 'common/enums/EntityTypeEnum';

export const PersonnelDetailType = new Enum({
    Name: 'name',
    Email: 'email'
});

export const PersonnelTypeEnum = new EntityTypeEnum({
    CLIENT: 'CLIENT_PERSONNEL',
    TRANSPORTER: 'TRANSPORTER_PERSONNEL'
});

export type PersonnelTypeEnumType = $Values<typeof PersonnelTypeEnum>;
